import { html } from '../utils';
const BREAKPOINT = 1024;
function getNextSibling(el, selector) {
    let sibling = el.nextElementSibling;
    if (!selector)
        return sibling;
    while (sibling && !sibling.matches(selector)) {
        sibling = sibling.nextElementSibling;
    }
    return sibling;
}
export class NavItem {
    el;
    menu;
    onClick;
    anyMenuOpen;
    constructor(el, onClick) {
        this.el = el;
        this.onClick = onClick;
        this.anyMenuOpen = !!(html && html?.classList.contains('menu-open'));
        const menu = getNextSibling(el, '.mobile-menu');
        if (!menu)
            throw new Error('Couldn\'t find mobile menu for nav item.');
        this.menu = menu;
        const backButton = menu?.querySelector('.menu-item--back-button');
        if (backButton) {
            backButton.addEventListener('click', () => {
                this.collapse();
            });
        }
        // Bind click
        const handleClick = this.handleClick.bind(this);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.el.addEventListener('click', handleClick);
        const closeButton = this.menu.querySelector('.close-menu');
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        closeButton?.addEventListener('click', handleClick);
        window.addEventListener('resize', this.handleResize.bind(this));
        this.update();
    }
    handleClick(event) {
        event.preventDefault();
        this.onClick(this);
    }
    get expanded() {
        return this.el.getAttribute('aria-expanded') === 'true';
    }
    handleResize() {
        this.update();
    }
    update() {
        const subMenu = this.menu.querySelector('.sub-menu');
        const closeButton = this.menu.querySelector('.close-menu');
        if (this.expanded) {
            this.menu.classList.remove('translate-x-full');
            this.menu.classList.add('z-10');
        }
        else {
            // Closed
            this.menu.classList.add('translate-x-full');
            this.menu.classList.remove('z-10');
        }
    }
    expand() {
        this.el.setAttribute('aria-expanded', 'true');
        this.update();
    }
    collapse() {
        this.el.setAttribute('aria-expanded', 'false');
        this.update();
    }
}
export class MobileMenu {
    el;
    bg;
    hamburger;
    hamburgerTopLine;
    hamburgerBottomLine;
    navItems;
    windowWidth = window.innerWidth;
    constructor(el) {
        this.el = el;
        this.bg = document.querySelector('.menu-bg > div');
        this.hamburger = document.getElementById('hamburger-menu');
        this.hamburgerTopLine = this.hamburger?.querySelector('.hamburger__top');
        this.hamburgerBottomLine = this.hamburger?.querySelector('.hamburger__bottom');
        // Create nav items
        this.onClickItem = this.onClickItem.bind(this);
        const items = el.querySelectorAll('.has-sub-menu > a');
        this.navItems = Array.from(items).map((item) => new NavItem(item, this.onClickItem));
        // Add event listeners
        this.hamburger?.addEventListener('click', this.toggle.bind(this));
        // Handle resize
        window.addEventListener('resize', this.handleResize.bind(this));
        this.handleResize();
    }
    get anyMenuOpen() {
        return this.navItems.some((item) => item.expanded);
    }
    collapseAll() {
        if (this.anyMenuOpen) {
            for (const item of this.navItems)
                item.collapse();
            this.updateGlobalClasses();
        }
    }
    handleResize() {
        if ((window.innerWidth >= BREAKPOINT && this.windowWidth < BREAKPOINT) ||
            (window.innerWidth < BREAKPOINT && this.windowWidth >= BREAKPOINT)) {
            // Collapse all menus on breakpoint change
            this.collapseAll();
        }
        this.windowWidth = window.innerWidth;
        // Update item sizes and global classes
        for (const item of this.navItems)
            item.update();
        this.updateGlobalClasses();
    }
    onClickItem(clickedItem) {
        for (const item of this.navItems) {
            if (item === clickedItem && !item.expanded)
                item.expand();
            //else item.collapse()
        }
        this.updateGlobalClasses();
    }
    updateGlobalClasses() {
        if (this.anyMenuOpen) {
            this.el?.classList.remove('translate-x-full');
            html?.classList.add('menu-open');
        }
        else {
            html?.classList.remove('menu-open');
            this.el?.classList.add('translate-x-full');
        }
    }
    get expanded() {
        return this.hamburger?.getAttribute('aria-expanded') === 'true';
    }
    toggle() {
        if (this.expanded)
            this.close();
        else
            this.open();
    }
    open() {
        this.hamburgerTopLine?.classList.remove('bg-white');
        this.hamburgerTopLine?.classList.add('bg-grey-400');
        this.hamburgerBottomLine?.classList.remove('bg-white');
        this.hamburgerBottomLine?.classList.add('bg-grey-400');
        this.el?.classList.remove('translate-x-full');
        this.hamburger?.classList.add('is-open');
        this.hamburger?.setAttribute('aria-expanded', 'true');
        // Disable body scroll
        html?.classList.add('overflow-hidden', 'h-screen', 'menu-open');
    }
    close() {
        this.hamburgerTopLine?.classList.add('bg-white');
        this.hamburgerTopLine?.classList.remove('bg-grey-400');
        this.hamburgerBottomLine?.classList.add('bg-white');
        this.hamburgerBottomLine?.classList.remove('bg-grey-400');
        this.hamburger?.classList.remove('is-open');
        this.hamburger?.setAttribute('aria-expanded', 'false');
        this.el?.classList.add('translate-x-full');
        this.collapseAll();
        this.hamburger?.setAttribute('aria-expanded', 'false');
        // Re-enable body scroll
        html?.classList.remove('overflow-hidden', 'h-screen', 'menu-open');
    }
}
